import RolloutPhase from './RolloutPhase';
import RolloutStatus from './RolloutStatus';
import RolloutStatusCounts from './RolloutStatusCounts';

export default class FirmwareRolloutDTO {

    public id: number;
    public studioId: number;
    public studioName: string;
    public firmwareRevisionId?: number;
    public targetReleaseVersion: string;
    public triggeredBy: string;
    public triggeredAt: string;
    public immediate: boolean;
    public status: RolloutStatus;
    public requestedSampleCount: number;
    public correlationId: string;
    public sampleCounts: RolloutStatusCounts;
    public phase: RolloutPhase;
    public pilotMacAddress?: string;

    constructor(data: { [key: string]: any }) {
        this.id = data['id'];
        this.studioId = data['studioId'];
        this.studioName = data['studioName'];
        this.firmwareRevisionId = data['firmwareRevisionId'];
        this.targetReleaseVersion = data['targetReleaseVersion'];
        this.triggeredBy = data['triggeredBy'];
        this.triggeredAt = data['triggeredAt'];
        this.immediate = data['immediate'];
        this.status = data['status'];
        this.requestedSampleCount = data['requestedSampleCount'];
        this.correlationId = data['correlationId'];
        this.sampleCounts = new RolloutStatusCounts(data['sampleCounts'] ?? {});
        this.phase = data['phase'];
        this.pilotMacAddress = data['pilotMacAddress'];
    }
}
